(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Menu mobile */
  var burger = document.getElementById('sr-burger'), menu = document.getElementById('sr-menu');
  if (burger && menu) burger.addEventListener('click', function () { var o = menu.classList.toggle('open'); burger.setAttribute('aria-expanded', o); });

  /* Menus déroulants : un seul ouvert, fermeture au clic dehors ou Échap */
  var dds = document.querySelectorAll('.dd');
  dds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) dds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
  document.addEventListener('click', function (e) { dds.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') dds.forEach(function (d) { d.open = false; }); });

  /* Tapis dessinés */
  var AR = { ul: 'M7 17V7h10M7 7l10 10', u: 'M12 19V5M5 12l7-7 7 7', ur: 'M7 7h10v10M17 7L7 17', l: 'M19 12H5M12 5l-7 7 7 7', r: 'M5 12h14M12 5l7 7-7 7', dl: 'M17 17H7V7M7 17L17 7', d: 'M12 5v14M5 12l7 7 7-7', dr: 'M7 17h10V7M17 17L7 7' };
  var COL = { ul: '#ff4fa3', u: '#2fd6ff', ur: '#b8f34a', l: '#ffc93d', r: '#ff4fa3', dl: '#b8f34a', d: '#2fd6ff', dr: '#ffc93d' };
  document.querySelectorAll('[data-mat]').forEach(function (el) {
    el.innerHTML = ['ul', 'u', 'ur', 'l', 'mid', 'r', 'dl', 'd', 'dr'].map(function (k) {
      return k === 'mid' ? '<div class="pad mid">' + el.getAttribute('data-mat') + '</div>' : '<div class="pad" style="--c:' + COL[k] + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + AR[k] + '"/></svg></div>';
    }).join('');
    var pads = el.querySelectorAll('.pad:not(.mid)');
    if (reduce) { pads[1].classList.add('lit'); return; }
    setInterval(function () { if (document.hidden) return; pads.forEach(function (p) { p.classList.remove('lit'); }); pads[Math.floor(Math.random() * pads.length)].classList.add('lit'); }, 520);
  });

  /* Toast */
  var toast = document.getElementById('sr-toast'), tt;
  function say(m) { if (!toast) return; toast.textContent = m; toast.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('on'); }, 2800); }
  window.srSay = say;

  /* Sélecteur d'âge */
  document.querySelectorAll('[data-ages]').forEach(function (g) {
    var res = document.getElementById(g.getAttribute('data-ages'));
    g.addEventListener('click', function (e) {
      var b = e.target.closest('.age'); if (!b) return;
      g.querySelectorAll('.age').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      res.innerHTML = b.getAttribute('data-res');
    });
  });

  /* Date de livraison estimée (jours ouvrés) */
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; }
  function f(d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); }
  document.querySelectorAll('[data-eta]').forEach(function (el) {
    var now = new Date();
    var g = function (d) { return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }).replace('.', ''); };
    var a = addBiz(now, 9), z = addBiz(now, 10);
    var liv = a.getMonth() === z.getMonth() ? a.getDate() + '-' + g(z) : g(a) + ' - ' + g(z);
    el.innerHTML = '<ol class="eta-bar" aria-label="Livraison estimée">'
      + '<li class="done"><span class="dot"><svg class="si" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg></span><b>Aujourd\'hui</b></li>'
      + '<li><span class="dot"><svg class="si" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/></svg></span><b>' + g(addBiz(now, 3)) + '</b></li>'
      + '<li><span class="dot"><svg class="si" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 11 12 4l8.5 7"/><path d="M6 9.5V20h12V9.5"/><path d="M10 20v-5h4v5"/></svg></span><b>' + liv + '</b></li></ol>';
  });

  var fmt = function (cents) {
    var tpl = window.srMoney || '{{amount_with_comma_separator}} €';
    return tpl.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var a = (cents / 100).toFixed(2), parts = a.split('.'), int = parts[0], dec = parts[1];
      if (k.indexOf('no_decimals') > -1) { dec = ''; int = Math.round(cents / 100).toString(); }
      if (k.indexOf('comma') > -1) return int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (dec ? ',' + dec : '');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (dec ? '.' + dec : '');
    });
  };
  var ROOT = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  /* Panier déroulant */
  var drawer = document.getElementById('sr-drawer'), dBody, dFoot;
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function upsell(cart) {
    var box = drawer.querySelector('.dr-up'), L = window.srLots || [];
    var lines = cart.items.filter(function (it) { return L.some(function (v) { return v.id === it.variant_id; }); });
    box.hidden = true;
    if (lines.length !== 1 || lines[0].quantity !== 1 || L.length < 3) return;
    var cur = L.filter(function (v) { return v.id === lines[0].variant_id; })[0];
    var next = L[cur.n]; if (!next) return;
    var extra = next.price - cur.price, save = next.cmp > next.price ? next.cmp - next.price : 0;
    var line = cart.items.indexOf(lines[0]) + 1;
    box.innerHTML = '<div class="up-steps" aria-hidden="true">' + L.map(function (v) { return '<span class="' + (v.n <= cur.n ? 'on' : '') + '">' + v.n + '</span>'; }).join('<i class="' + (cur.n >= 2 ? '' : '') + '"></i>') + '</div>' +
      (cur.n === 1
        ? '<p><b>Un frère ou une sœur ? Prenez-en deux !</b><br>Le 2e tapis à ' + fmt(extra) + ', vous économisez ' + fmt(save) + '.</p>'
        : '<p><b>Un cousin, une copine ? Et de trois !</b><br>Le 3e tapis à ' + fmt(extra) + ' seulement, soit -25 % sur le lot.</p>') +
      '<button type="button" class="up-btn" data-swap="' + next.id + '" data-swap-line="' + line + '">Oui, ' + next.n + ' tapis →</button>';
    var fill = box.querySelectorAll('.up-steps i'); fill.forEach(function (i, k) { if (k < cur.n - 1) i.className = 'on'; });
    box.hidden = false;
  }
  function render(cart) {
    setCount(cart.item_count);
    upsell(cart);
    if (!cart.item_count) {
      dBody.innerHTML = '<div class="dr-empty"><p>Votre panier est vide.</p><a class="btn btn-main" href="' + ROOT + 'products/tapis-de-danse-lumineux">Voir le tapis</a></div>';
      dFoot.hidden = true; return;
    }
    dBody.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      return '<div class="dr-line">' + (img ? '<img src="' + img + '" alt="" width="72" height="72">' : '<span></span>') +
        '<div><b>' + esc(it.product_title) + '</b>' + (it.variant_title ? '<small>' + esc(it.variant_title) + '</small>' : '') +
        '<div class="dr-qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Retirer un">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button></div></div>' +
        '<div class="dr-price"><b>' + fmt(it.final_line_price) + '</b><button type="button" class="dr-rm" data-line="' + (i + 1) + '" data-q="0">Retirer</button></div></div>';
    }).join('');
    dFoot.hidden = false;
    dFoot.querySelector('[data-total]').textContent = fmt(cart.total_price);
  }
  function load() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render); }
  function openDrawer() {
    if (!drawer) { window.location.href = ROOT + 'cart'; return; }
    drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('on'); });
    document.documentElement.style.overflow = 'hidden';
    load(); var c = drawer.querySelector('.dr-close'); c && c.focus();
  }
  function closeDrawer() {
    if (!drawer) return; drawer.classList.remove('on'); document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 250);
  }
  window.srOpenCart = openDrawer;
  if (drawer) {
    dBody = drawer.querySelector('.dr-body'); dFoot = drawer.querySelector('.dr-foot');
    drawer.addEventListener('click', function (e) {
      if (e.target.matches('.dr-overlay, .dr-close')) { closeDrawer(); return; }
      var sw = e.target.closest('[data-swap]');
      if (sw) {
        sw.disabled = true; sw.textContent = 'Un instant…';
        var post = function (u, b) { return fetch(ROOT + u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }); };
        post('cart/change.js', { line: +sw.getAttribute('data-swap-line'), quantity: 0 })
          .then(function () { return post('cart/add.js', { items: [{ id: +sw.getAttribute('data-swap'), quantity: 1 }] }); })
          .then(load).catch(function () { load(); });
        return;
      }
      var b = e.target.closest('[data-line]'); if (!b) return;
      b.disabled = true;
      fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.getAttribute('data-line'), quantity: Math.max(0, +b.getAttribute('data-q')) }) })
        .then(function (r) { return r.json(); }).then(render).catch(function () { b.disabled = false; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('on')) closeDrawer(); });
    document.querySelectorAll('[data-open-cart]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
  }

  /* Produit : offres, prix, ajout au panier */
  var form = document.getElementById('sr-product-form');
  if (form) {
    var priceEl = document.getElementById('sr-price'), wasEl = document.getElementById('sr-was'), saveEl = document.getElementById('sr-save');
    var addLabel = document.querySelectorAll('[data-add-price]');
    var current = form.querySelector('input[name="id"]:checked');
    function refresh() {
      current = form.querySelector('input[name="id"]:checked');
      var p = +current.getAttribute('data-price'), c = +current.getAttribute('data-compare');
      if (priceEl) priceEl.textContent = fmt(p);
      if (!wasEl || !saveEl) {} else if (c > p) { wasEl.textContent = fmt(c); wasEl.hidden = false; saveEl.textContent = 'Vous économisez ' + fmt(c - p); saveEl.hidden = false; }
      else { wasEl.hidden = true; saveEl.hidden = true; }
      addLabel.forEach(function (el) { el.textContent = fmt(p); });
    }
    form.addEventListener('change', refresh);
    refresh();
    function add(e) {
      if (e) e.preventDefault();
      var btns = document.querySelectorAll('[data-add]');
      btns.forEach(function (b) { b.disabled = true; });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +current.value, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || 'Erreur');
          btns.forEach(function (b) { b.disabled = false; });
          openDrawer();
        })
        .catch(function (err) { say('Oups, réessayez : ' + err.message); btns.forEach(function (b) { b.disabled = false; }); });
    }
    form.addEventListener('submit', add);
    var stickyAdd = document.getElementById('sr-sticky-add');
    if (stickyAdd) stickyAdd.addEventListener('click', add);

    /* Galerie : glisser au doigt ou à la souris */
    var track = document.getElementById('sr-track');
    if (track) {
      var slides = track.children, dots = document.querySelectorAll('.gal-dots i'), thumbs = document.querySelectorAll('[data-slide]');
      var idx = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      var go = function (i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
      var mark = function () { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('on', k === i); }); thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i); }); };
      track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(mark, 60); }, { passive: true });
      /* Vidéos : lecture seulement quand la vidéo est à l'écran */
      var vids = track.querySelectorAll('video');
      var playVis = function () { var i = idx(); vids.forEach(function (v) { var on = v.closest('.gal-slide') === slides[i]; if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); };
      if (vids.length) {
        vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); });
        track.addEventListener('scroll', function () { clearTimeout(track._v); track._v = setTimeout(playVis, 120); }, { passive: true });
        if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { if (es[0].isIntersecting) playVis(); else vids.forEach(function (v) { v.pause(); }); }, { threshold: .4 }).observe(track); else playVis();
        track.querySelectorAll('.vsound').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); var v = b.parentNode.querySelector('video'); v.muted = !v.muted; b.textContent = v.muted ? '🔇' : '🔊'; b.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son'); }); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-slide')); }); });
      var pv = document.querySelector('.gal-nav.prev'), nx = document.querySelector('.gal-nav.next');
      if (pv) pv.addEventListener('click', function () { go(idx() - 1); });
      if (nx) nx.addEventListener('click', function () { go(idx() + 1); });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(idx() - 1); if (e.key === 'ArrowRight') go(idx() + 1); });
      /* Glisser à la souris (le doigt utilise le défilement natif) */
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || slides.length < 2 || e.target.closest('.vsound')) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; track.classList.add('drag'); track.setPointerCapture(e.pointerId); });
      track.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 3) moved = true; track.scrollLeft = sl - dx; });
      var end = function (e) { if (!down) return; down = false; track.classList.remove('drag'); var dx = e.clientX - sx; var i = Math.round(sl / track.clientWidth); if (dx < -40) i++; else if (dx > 40) i--; go(i); };
      track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    }
  }

  /* Barre d'achat fixe : visible quand le bouton principal n'est plus à l'écran */
  var sticky = document.getElementById('sr-sticky');
  if (sticky) {
    var anchor = document.getElementById('sr-add') || document.getElementById('sr-hero-cta');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { sticky.classList.toggle('on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(anchor);
    } else sticky.classList.add('on');
  }
  /* Quel lot choisir : sur la fiche produit, coche le lot et remonte au bouton */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-lot]'); if (!a) return;
    var f = document.getElementById('sr-product-form'); if (!f) return;
    var r = f.querySelector('input[name="id"][value="' + a.getAttribute('data-lot') + '"]'); if (!r) return;
    e.preventDefault(); r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
    f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  /* Carrousel « Pourquoi les parents l'adorent » : défile tout seul, glisse au doigt */
  document.querySelectorAll('.fcar').forEach(function (c) {
    var tr = c.querySelector('.fcar-track'), sl = tr.children, dots = c.querySelectorAll('.fcar-dots i'), n = sl.length; if (n < 2) return;
    var cur = function () { return Math.round(tr.scrollLeft / (sl[0].offsetWidth + 14)); };
    var go = function (i) { tr.scrollTo({ left: ((i + n) % n) * (sl[0].offsetWidth + 14), behavior: 'smooth' }); };
    tr.addEventListener('scroll', function () { clearTimeout(tr._t); tr._t = setTimeout(function () { var i = cur(); dots.forEach(function (d, k) { d.classList.toggle('on', k === i); }); }, 60); }, { passive: true });
    var ms = (+c.getAttribute('data-auto') || 4) * 1000, paused = false, t;
    var loop = function () { clearInterval(t); if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; t = setInterval(function () { if (!paused && !document.hidden) go(cur() + 1); }, ms); };
    ['pointerdown', 'mouseenter', 'focusin'].forEach(function (ev) { c.addEventListener(ev, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { c.addEventListener(ev, function () { paused = false; }); });
    c.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { if (es[0].isIntersecting) loop(); else clearInterval(t); }).observe(c); else loop();
  });
  /* Quel lot choisir : onglets */
  document.querySelectorAll('[data-lg]').forEach(function (g) {
    var tabs = g.querySelectorAll('.lg-tab'), panels = g.querySelectorAll('.lg-panel');
    tabs.forEach(function (tb, i) { tb.addEventListener('click', function () { tabs.forEach(function (x, k) { x.setAttribute('aria-selected', k === i); }); panels.forEach(function (p, k) { p.hidden = k !== i; }); }); });
  });
})();
